<template>
  <div :class="['home-container']">
    <div class="language-wrapper my-lang-wrap">
      <SingleButtonToggleLanguage
        class="language"
        :language-chosen="languageHome"
        :set-language-chosen="setLanguageHome"
        :speaker-nickname
        area="home"
      />
    </div>
    <ContainerChatAutoScroll class="chat-home-container">
      <SingleMessageChat v-for="message in messageList" :key="message.callLogId" :message area="home" />
      <GeneralMessageCredit :domain="domain" />
    </ContainerChatAutoScroll>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, provide, Ref } from 'vue';
import { useI18n } from 'vue-i18n';

import GeneralMessageCredit from '@/components/domains/chat/chat-general/GeneralMessageCredit.vue';
import SingleButtonToggleLanguage from '@/components/domains/chat/chat-single/SingleButtonToggleLanguage.vue';
import SingleMessageChat from '@/components/domains/chat/chat-single/SingleMessageChat.vue';
import ContainerChatAutoScroll from '@/components/shared/composite/ContainerChatAutoScroll.vue';
import { useMessagesSingle } from '@/composables/domains/chat/useMessagesSingle';
import { Language, TypeDomain } from '@/types/common';
import { ij_languageArea, ij_languageHome, ij_setLanguageHome } from '@/utils/injectionKeys.js';

withDefaults(
  defineProps<{
    domain?: TypeDomain;
  }>(),
  {
    domain: 'CHAT',
  }
);

const { messages } = useI18n();

const languageHome = inject(ij_languageHome) as Ref<Language>;
const setLanguageHome = inject(ij_setLanguageHome) as () => void;

const { messageList } = useMessagesSingle();

const speakerNickname = computed(() => {
  return String(messages.value?.[languageHome.value?.code]['entrance_intro_message_1']);
});

provide(
  ij_languageArea,
  computed(() => languageHome.value.code)
);
</script>

<style scoped lang="scss">
.chat-home-container {
  width: 100%;
  height: 100%;
}

.home-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  gap: 0.5rem;
  overflow-y: auto;
}

.language-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
